let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
import React from "ES/lib/react";

let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../utils/FormUtils');
let SlideOpenDown = require('../../widgets/SlideOpenDown');
let HorizontalFields = require('ES/widgets/HorizontalFields');
var ServicesUtils = require('ES/utils/ServicesUtils');
let ErrorAlert = require('ES/widgets/ErrorAlert');

let SettingsForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props;
    },
    getInitialValues: function (props) {

        return _.get(props, "initvals", {});

    },
    buildFields: function () {
        return {
            contact_url: {
                label: 'contact us URL',
                type: 'text',
                placeholder: 'https://mywebsite.com/contact',
                validate: FormUtils.v.optional
                // },
                // sales_url: {
                //     label: 'product sales URL',
                //     type: 'text',
                //     placeholder: 'https://mywebsite.com/salesinfo',
                //     validate: FormUtils.v.optional
                // },
                // recording_url: {
                //     label: 'recording permission sales URL',
                //     type: 'text',
                //     placeholder: 'https://mywebsite.com/recordinginfo',
                //     validate: FormUtils.v.optional
                // }
            }
        };
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),

    render: function () {
        let fields = this.buildFields();
        let errors = this.state.errors || {};
        let changes_made = this._form_areChangesMade();
        let error_msg = _.get(this.props, "error_msg");
        let success_msg = _.get(this.props, "success_msg");

        return <form className='form-horizontal' onSubmit={this._form_onSubmit}>
            <h3>Links</h3>

            <p>Enter links back to your website that are used on the Client Portal.</p>
            {HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            })}
            {SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
            }
            {success_msg && !changes_made &&
            <div className="alert alert-success">
                Saved.
            </div>}
            {ErrorAlert({
                message: error_msg
            })}
        </form>;
    }
});

module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_links")],

    getInitialState: function () {
        return {
            sid: -1,
            data: {},
            is_saving: false,
            error_msg: null,
            changes_made: false,
            success_msg: null
        };
    },
    componentWillReceiveProps(props) {
        _.set(props, "config.urls.sid", _.get(props, "config.sid"));
        this.setState({sid: props.config.sid, config: props.config, data: props.config.urls, success_msg: null, error_msg: null});
    },
    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into SettingsForm() as a parameter
    __onSubmit: function (data) {
        let self = this;

        radio('save_ClientPortal_links').broadcast(data.sid, data,
            function (sid, data) {
                if (_.get(self, "state.data.sid") == sid) {
                    self.setState({
                        sid: sid,
                        config: data,
                        data: data.urls,
                        is_saving: false,
                        error_msg: null,
                        changes_made: false,
                        success_msg: "Saved."
                    });
                }
            },
            function (sid, message) {
                self.setState({error_msg: message, success_msg: null});
            });
    },
    __selectTextInput: function (e) {
        e.target.setSelectionRange(0, e.target.value.length);
    },
    render: function () {
        let {speaker, Displaylists} = this.props;

        return dd.div({},
            SettingsForm({
                    speaker,
                    Displaylists,
                    config: _.get(this, "state.config"),
                    initvals: this.state.data,
                    onSubmit: this.__onSubmit,
                    error_msg: _.get(this.state, "error_msg"),
                    success_msg: _.get(this.state, "success_msg")
                }
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/ClientPortal/LinksForm.js